import Vue from 'vue'

Vue.filter('permalinkfilter', function(input) {
  if (input) {
    var expresion = /(http[s]?:\/\/)?([^\/\s]+\/)(.*)/i
    var check = input.match(expresion)
    return `/${check[ 3 ]}`
  }
  return ''
})
